import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/header/Header';
import Home from './components/home/Home';
import About from './components/about/About';
import Gallery from './components/gallery/Gallery';
import Writing from './components/writing/Writing';

// Scroll ke atas saat ganti route
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Header/>
        <main className='main'>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Home/>
                  <Gallery/>
                  <Writing/>
                </>
              }
            />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </Router>
    </>
  )
}

export default App;
